import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import MappingForm from '../MappingForm';

import { SquareButton } from '../../../../Styles';
import { EditIcon } from '../../../../Styles';
import MappingFormV2 from '../MappingFormV2';

const UpdateMapping = ({ item = {}, mapping = {}, refresh = null, ...props }) => {
	const { disableSingleInventoryMapping } = props;
	const { supplier_product_id: itemId, name: itemName } = item;
	const [openUpdateMapping, setOpenUpdateMapping] = useState(false);

	return (
		<>
			{!disableSingleInventoryMapping && (
				<SquareButton
					outline
					secondary
					onClick={(e) => setOpenUpdateMapping(true)}
				>
					<EditIcon />
				</SquareButton>
			)}

			{/* <MappingForm
				open={openUpdateMapping}
				item={{ itemId, itemName }}
				mapping={mapping}
				onSubmit={() => {
					if (refresh) {
						refresh();
					}
				}}
				onClose={() => {
					setOpenUpdateMapping(false);
				}}
			/> */}
			<MappingFormV2
				open={openUpdateMapping}
				item={{ itemId, itemName }}
				mapping={mapping}
				onSubmit={() => {
					if (refresh) {
						refresh();
					}
				}}
				onClose={() => {
					setOpenUpdateMapping(false);
				}}
			/>
		</>
	);
};

const mapStateToProps = (state) => {
	const supplierSellerPortalConfig = state.supplier.sellerPortalConfig || {};
	const userSellerPortalConfig = state.session.sellerPortalConfig || {};

	const disableSingleInventoryMapping = supplierSellerPortalConfig.disable_single_inventory_mapping || userSellerPortalConfig.disable_single_inventory_mapping || false;

	return {
		disableSingleInventoryMapping,
	};
};

const mapDispatch = {};

export default withRouter(connect(mapStateToProps, mapDispatch)(UpdateMapping));
